import {
  Component,
  Input,
  AfterViewInit,
  ElementRef,
  ViewChild
} from '@angular/core';
import { PageLoaderService } from '../../../components/loader/page-loader.service';

@Component({
  selector: 'ls-page',
  templateUrl: './page.component.html',
  styleUrls: ['page.component.scss']
})
export class PageComponent implements AfterViewInit {
  @Input()
  public useGrid = false;
  @Input()
  public noLayout = false;
  @Input()
  public gray = false;
  @Input()
  public flame = false;
  @Input()
  public noHeader = false;
  @Input()
  public showPastDueBanner = false;

  @ViewChild('content')
  public el: ElementRef;

  constructor(
    private loadingService: PageLoaderService,
    private elemRef: ElementRef
  ) {}

  public ngAfterViewInit(): void {
    if (
      this.elemRef.nativeElement.getElementsByTagName('ls-iframe').length === 0
    ) {
      this.loadingService.setLoaded();
    }
  }
}
